import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AddPipelineModal } from "../../components/Modal/PipelineModal/AddPipelineModal/AddPipelineModal";
import { EditPipelineModal } from "../../components/Modal/PipelineModal/EditPipelineModal/EditPipelineModal";
import { ActivePipelineContextProvider } from "../../providers/ActivePipelineContextProvider";
import { Page } from "../Page/Page";
import Pipeline from "./components/Pipeline";
import { PipelineHeader } from "./components/PipelineHeader/PipelineHeader";
const PipelinePage = () => {
    return (_jsx(ActivePipelineContextProvider, { children: _jsxs(Page, { children: [_jsx(PipelineHeader, {}), _jsx(Pipeline, {}), _jsx(AddPipelineModal, {}), _jsx(EditPipelineModal, {})] }) }));
};
export { PipelinePage };
